import styled from 'styled-components';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

const PhoneInput = styled(IntlTelInput)`
  & .form-control {
    height: 200px !important;
  }
`

export default PhoneInput;
